import React from "react";
import Switch from "react-switch";
import { COLORS } from "@app/constants";
import { useWindowDimensions } from "@app/hooks";
import { Text, View } from "@/styles/reactnative";
import { useTranslation } from "react-i18next";
import {useIsMobile} from "@utils/CalVW.tsx";

interface IProps {
  title?: string;
  checked?: any;
  setChecked?: any;
}
const NotiSwitch = ({ title, checked, setChecked }: IProps) => {
  const { t } = useTranslation();
  const { width } = useWindowDimensions();
  const isMobile = useIsMobile();

  return (
    <View
      style={{
        flexDirection: isMobile ? 'column' : "row",
        alignItems: isMobile ? 'flex-start' : "center",
        justifyContent: "space-between",
        marginTop: 30,
        width: '100%'
      }}
    >
      <Text
        size={19}
        style={{
          fontWeight: "400",
          lineHeight: isMobile ? 1 : 1.2,
          marginBottom: isMobile ? 10 : 0,
        }}
      >
        {title}
      </Text>

      <Switch
        onChange={(e) => setChecked(!checked)}
        checked={checked}
        onColor={'#007AFF'}
        checkedIcon={
          <Text
            size={12}
            style={{
              paddingTop: width < 600 ? 12 : 8,
              fontWeight: "500",
              color: COLORS.white,
            }}
          >
            {/*{t("on")}*/}
          </Text>
        }
        uncheckedIcon={
          <Text
            size={12}
            style={{
              paddingTop: width < 600 ? 12 : 8,
              fontWeight: "500",
              color: COLORS.white,
            }}
          >
            {/*{t("off")}*/}
          </Text>
        }
      />
    </View>
  );
};
export default NotiSwitch;
